import { createContext } from "react";
export const CartContext = createContext([]);
export const formDataContext = createContext([]);
